/** AI doubt-clearing tutor: ask a question in any language, get the answer in
 *  that same language. */
import { request } from "./http";

export interface DoubtAnswer {
  configured: boolean;
  answer: string;
}

export function askDoubt(question: string, context?: string): Promise<DoubtAnswer> {
  return request("/tutor/doubt", { method: "POST", body: { question, context } });
}
